import { z } from 'zod';

// A supplier user's name comes from the contact the client created — it's not entered here.
export const acceptInviteSchema = z.object({
  password: z.string().min(8, 'At least 8 characters'),
  confirmPassword: z.string(),
}).refine(d => d.password === d.confirmPassword, {
  message: "Passwords don't match",
  path: ['confirmPassword'],
});
export type AcceptInviteForm = z.infer<typeof acceptInviteSchema>;
